import React from 'react';
import { connect } from 'react-redux';
import { Formik } from 'formik';

import ChangeStatusForm from '../../../Forms/EconomicProposal/ChangeStatusForm';

import { updateProposal } from '../../../../store/actions/ProposalsAction';
import {
  showLoading,
  hideLoading,
} from '../../../../store/actions/LoadingActions';

const ChangeProposalStatus = ({
  changeStatus,
  handleClose,
  showLoading,
  hideLoading,
  updateProposal,
  proposal,
}) => {

  const submitChangeStatus = (values, { setSubmitting }) => {
    setSubmitting(false);
    showLoading();
    try {
      changeStatus(values.status)
      hideLoading();
    } catch (error) {
      console.error(error)
    }
    
  }

  return (
    <Formik
      initialValues={{
        status: proposal.status,
      }}
      //validationSchema={validationPassword}
      onSubmit={submitChangeStatus}
      render={(props) => (
        <ChangeStatusForm
          handleSubmit={changeStatus}
          handleClose={handleClose}
          {...props}
        />
      )}
    />
  );
};

const mapDispatchToProps = (dispatch) => ({
  showLoading: () => dispatch(showLoading()),
  hideLoading: () => dispatch(hideLoading()),
  updateProposal: (proposal, proposalsArray, uid) => dispatch(updateProposal(proposal, proposalsArray, uid)),
});

export default connect(null, mapDispatchToProps)(ChangeProposalStatus);
